export function truncate(text, limit, after) {
	if (!text || !limit) return;

	text = text.trim();

    if(text.length > limit) {
        text = text.slice(0, limit)
        text = text.trim();
        text = text + after;
    }
    return text;
}


// WEBPACK FOOTER //
// ./src/helpers/truncate.js